import {toBillingTermsInput} from '../projects/create-project-submit'
import {toWizardFormValues} from '../projects/project-billing-terms-utils'
import type {CreateProjectInput} from '../projects/schemas'
import {resolveStageJobName} from '../service-schedules/build-out-logic'
import type {CreateJobFormValues} from './types'

function buildNewWorkProjectName(values: CreateJobFormValues): string {
    return (
        values.jobName.trim() ||
        resolveStageJobName(values.scheduling, 'deploy').trim() ||
        'New order'
    )
}

export function newWorkProjectInput(values: CreateJobFormValues): CreateProjectInput {
    const {customerId, internalContactId} = values
    if (!customerId || !internalContactId) {
        throw new Error('Customer and rep are required')
    }
    return {
        customerId,
        name: buildNewWorkProjectName(values),
        description: '',
        notes: '',
        internalContactId,
        customerContactId: values.customerContactId,
        poNumber: values.poNumber.trim() || null,
        dispatchYardId: values.dispatchYardId ?? null,
        billingTerms: toBillingTermsInput(
            toWizardFormValues({
                billingMethod: values.billingMethod,
                billingTerms: values.billingTerms,
            }),
        ),
    }
}

export function describeJobCreationFailure(error: unknown): {title: string; message: string} {
    return {
        title: 'Failed to create job',
        message: error instanceof Error ? error.message : 'Something went wrong',
    }
}
